import { render, staticRenderFns } from "./monijiaoyi.vue?vue&type=template&id=64141fd0"
import script from "./monijiaoyi.vue?vue&type=script&lang=js"
export * from "./monijiaoyi.vue?vue&type=script&lang=js"
import style0 from "./monijiaoyi.vue?vue&type=style&index=0&id=64141fd0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports